import React from "react"
import { HandleAvailabilityStatus } from "~/__generated__/graphql"
import { cn } from "~/common/cn"

interface HandleAvailabilityStatusProps {
  status: "checking" | HandleAvailabilityStatus | null
  currentHandle?: string
  originalHandle?: string | null | undefined
  className?: string
}

export const HandleAvailabilityStatusDisplay: React.FC<HandleAvailabilityStatusProps> = ({
  status,
  currentHandle,
  originalHandle,
  className = "",
}) => {
  // Don't show anything if no status or if handle is available but unchanged (and originalHandle exists)
  if (
    !status ||
    (status === HandleAvailabilityStatus.Available &&
      originalHandle &&
      currentHandle === originalHandle)
  ) {
    return null
  }

  const getStatusMessage = () => {
    switch (status) {
      case "checking":
        return "Checking availability..."
      case HandleAvailabilityStatus.Available:
        return "That handle is available!"
      case HandleAvailabilityStatus.Taken:
        return "That handle is already taken"
      case HandleAvailabilityStatus.InvalidFormat:
        return "Handle can only contain letters, numbers, and underscores"
      case HandleAvailabilityStatus.TooShort:
        return "Handle must be at least 3 characters long"
      case HandleAvailabilityStatus.TooLong:
        return "Handle must be 24 characters or less"
      case HandleAvailabilityStatus.Empty:
      case null:
        return ""
      default:
        throw status satisfies never
    }
  }

  return (
    <div
      className={cn(
        "rounded-md px-3 py-2 text-sm",
        {
          "bg-green-100 text-green-800": status === HandleAvailabilityStatus.Available,
          "bg-gray-100 text-gray-600": status === "checking",
          "bg-red-100 text-red-800":
            status !== HandleAvailabilityStatus.Available && status !== "checking",
        },
        className
      )}
    >
      {getStatusMessage()}
    </div>
  )
}
